export function sanitizeString(stringValue: string): string {
  // Remplace les caractères accentués
  const accentsMap: { [key: string]: string } = {
    à: "a",
    â: "a",
    ä: "a",
    á: "a",
    ã: "a",
    å: "a",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    î: "i",
    ï: "i",
    í: "i",
    ì: "i",
    ô: "o",
    ö: "o",
    ó: "o",
    ò: "o",
    õ: "o",
    ù: "u",
    û: "u",
    ü: "u",
    ú: "u",
    ç: "c",
    ñ: "n",
  }

  const accentsRegex = /[àâäáãåèéêëîïíìôöóòõùûüúùçñ]/g

  let clean = stringValue.replace(accentsRegex, (match: string) => accentsMap[match])

  // Remplace les caractères spéciaux par un _
  clean = clean.replace(/[^a-zA-Z0-9]/g, "_")

  return clean
}

export function sanitizeFileName(fileName: string): string {
  // Mappage des caractères accentués
  const accentsMap: { [key: string]: string } = {
    à: "a",
    â: "a",
    ä: "a",
    á: "a",
    ã: "a",
    å: "a",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    î: "i",
    ï: "i",
    í: "i",
    ì: "i",
    ô: "o",
    ö: "o",
    ó: "o",
    ò: "o",
    õ: "o",
    ù: "u",
    û: "u",
    ü: "u",
    ú: "u",
    ç: "c",
    ñ: "n",
  }

  const accentsRegex = /[àâäáãåèéêëîïíìôöóòõùûüúçñ]/g

  // Séparer le nom du fichier et l'extension
  const lastDotIndex = fileName.lastIndexOf(".")
  let namePart = fileName
  let extensionPart = ""

  if (lastDotIndex !== -1) {
    namePart = fileName.substring(0, lastDotIndex)
    extensionPart = fileName.substring(lastDotIndex)
  }

  // Remplacer les caractères accentués dans le nom du fichier
  let cleanName = namePart.replace(accentsRegex, (match: string) => accentsMap[match])

  // Remplacer les caractères spéciaux par des underscores
  cleanName = cleanName.replace(/[^a-zA-Z0-9]/g, "_")

  // Reconstruire le nom de fichier avec l'extension
  return cleanName + extensionPart
}
